import React from 'react';
const Spinner = () => {
    return (
        <div className="core">
            <div className='heroes main'><h1>Cargando...</h1></div>
            <div className='preSpinner'><div className='spinner'></div></div>
        </div>
    )
}

export default Spinner;